import 'whatwg-fetch'; /* Internet explorer does not support Fetch API */

import * as Context from "kiosk/Context/context.js";
import KioskApp from "kiosk/KioskApp";

export { KioskApp, Context };


window.addEventListener('load', () => {

    var initialUrl = location.href;


    Context.loadUrlContext( initialUrl ).then( function(context){

        var kioskOptions = context;
        kioskOptions.resetUrl = initialUrl;

        var container = document.getElementById("kiosk-app-container");

        window.mazemapKiosk = new KioskApp(container, kioskOptions);

    }).catch( function(err){
        console.log('Error initializing the app', err); //eslint-disable-line
    });
});


// WEBPACK FOOTER //
// src/index.kiosk.v1.js